import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewChild,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import { FontDataForSignature, Questions } from 'src/app/common-class/questions';
import { Group, Matrix } from 'src/app/common-class/pages';
import { CommonLogic } from 'src/app/COMMON-LOGIC/common-logic';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { AnswerImage } from 'src/app/common-class/answer-image';
import { AnswerMedia } from 'src/app/common-class/answer-media';
import { PreviewData } from 'src/app/common-class/survey';
import { NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { environment } from 'src/environments/environment';
declare const $: any;

@Component({
  selector: 'app-multiple-text-box',
  templateUrl: './multiple-text-box.component.html',
  styleUrls: ['./multiple-text-box.component.css'],
})
export class MultipleTextBoxComponent implements OnInit {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() group: Group;
  @Input() matrix: Matrix;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;
  @Input() isSignatureControl: boolean;
  @Input() isSubmitted: boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  firstQuestion: Questions;
  singleImageArray: Array<number> = [];
  multiImageArray: Array<number> = [];

  tempArray = [];
  questionsArray: any;
  columnWidth: any;
  isNewParticipation: boolean;
  surveyFormat: number = 0;
  newParticipationBtnText: string;
  verticalClassName: string;
  isAnsChange: boolean;
  isPreReadQn: boolean;
  resetPageSub: any;
  isResetPage: boolean = false;

  //Signature Property
  isSetImage: boolean = false;
  signatureImg: string = null;
  setControlValue: number = 0;
  setControlTypeValue: number = 1;
  isfontChangeOpen: boolean = false;
  isLoaderOnImage: boolean = false;
  Signature_SaveConfirm: string;
  Signature_Clear: string;
  Signature_TapSignHere: string;
  Signature_ClickSignHere: string;
  Signature_UploadSignature: string;
  Signature_TypeHere: string;
  isErrormsg_fullwidth: boolean = false;
  isAnySubQMandatory: boolean = false;
  isEditResponse: boolean = false;

  @ViewChild(SignaturePadComponent, { static: false }) signaturePad: SignaturePadComponent;
  signaturePadOptions: NgSignaturePadOptions = {
    backgroundColor: 'white',
    minWidth: 2,
    canvasWidth: 400,
    canvasHeight: 200,
  };

  selectedFontName: string = 'Montserrat';
  fontDataForSignature: FontDataForSignature[] = [];
  selectFontValue: number = -1;
  textSignatureValue: string;
  fontPixel: number = 24;
  ischangeStyle: boolean = false;
  isrtl: boolean = false;
  selectedFontData: FontDataForSignature;

  ngOnChanges(changes: SimpleChanges) {
    let change = changes['JsonData'];
    if (change != undefined && change != null) {
      let curVal = JSON.stringify(change.currentValue);
      let preVal = JSON.stringify(change.previousValue);
      if (this.isSignatureControl) {
        if (curVal != preVal && preVal != undefined) {
          this.questions = JSON.parse(this.JsonData);
          this.firstQuestion = this.questions[0];
          if (this.firstQuestion.AnswerText == null && !this.firstQuestion.isValid) {
            this.clearControl();
          }
          this.questions = this.questions.filter((e) => !e.isHiddenQ);
        }
      } else {
        if (
          curVal != preVal &&
          preVal != undefined &&
          (this.isNgOnchangeCall() || this.isQuesionHideInQDL())
        ) {
          this.questions = JSON.parse(this.JsonData);
          if (this.group.answer_style == 1) {
            this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
          }
          if (this.matrix?.MultiColumnCount > 1) {
            this.HorizontalHandling();
          }
          this.ngAfterViewInit();
          this.isResetPage = false;
          this.questions = this.questions.filter((e) => !e.isHiddenQ);
        }
      }
    }
  }
  constructor(
    private service: ParticipationDataService,
    private previewData: PreviewData,
    private changeDetect: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);
      if (this.service.getRTL()) {
        this.isrtl = true;
      }
      this.questions = this.questions?.filter((e) => !e.isHiddenQ);
      this.isEditResponse = this.service.getisEditResponse();
      if (
        this.questions?.filter((e) => e.mandatory) != undefined &&
        this.questions?.filter((e) => e.mandatory).length > 0
      ) {
        this.isAnySubQMandatory = true;
      }
      if (!this.isSignatureControl) {
        let fstQn = this.questions?.[0];
        if (fstQn != undefined && fstQn != null) {
          this.firstQuestion = fstQn;
        }

        let imgQn = this.questions?.find((e) => e.sub_qno == 1);
        if (imgQn != undefined && imgQn != null) {
          this.imgQuestion = imgQn;
        }
        if (this.group?.answer_style == 1) {
          this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
        } else if (this.group?.answer_style == 0 && this.questions.length > 1) {
          this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
        } else if (
          this.group?.answer_style == 2 &&
          this.questions[0].grpRotateIndex != -1 &&
          this.questions.length > 1
        ) {
          this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);

          CommonLogic.RotateQuestionsHandling(this.questions);
        }
        if (this.matrix?.MultiColumnCount > 1) {
          this.HorizontalHandling();
        }
        this.verticalClassName = this.getVerticalClass();
      } else {
        this.firstQuestion = this.questions[0];
        this.imgQuestion = this.questions[0];

        if (this.firstQuestion.AnswerText != null && this.firstQuestion.AnswerText != undefined) {
          const current = new Date();
          this.signatureImg =
            this.service.getCommonSetting().SurveyFileUploadFolder +
            '\\' +
            this.firstQuestion.AnswerText +
            '?v=' +
            current.getTime();
          this.setControlValue = 4;
        } else if (this.isEditResponse == true) {
          this.signatureImg = environment.ms_host_ssl + '/allimages/images/blank.gif';
        } else {
          this.signatureImg = null;
        }

        if (this.group.IsScribbledSignature) {
          this.setControlTypeValue = 1;

          if (this.isMobile) {
            this.signaturePadOptions = {
              backgroundColor: 'white',
              minWidth: 2,
              canvasWidth: 260,
              canvasHeight: 144,
            };
          }
        } else if (this.group.IsUploadImageSignature) {
          this.setControlTypeValue = 2;
        } else if (this.group.IsTypeSignature) {
          this.setControlTypeValue = 3;
        }

        if (this.group.IsTypeSignature) {
          this.fontDataForSignature.push(
            {
              Font_id: -1,
              Font_Name: 'Montserrat',
              DefaultFont_Size: 22,
              CharBetween23_30: 16,
              CharBetween31_40: 14,
              CharBetween41_100: 10,
            },
            {
              Font_id: 1,
              Font_Name: 'Homemade Apple',
              DefaultFont_Size: 20,
              CharBetween23_30: 14,
              CharBetween31_40: 12,
              CharBetween41_100: 10,
            },
            {
              Font_id: 4,
              Font_Name: 'Fuggles',
              DefaultFont_Size: 44,
              CharBetween23_30: 36,
              CharBetween31_40: 28,
              CharBetween41_100: 22,
            },
            {
              Font_id: 5,
              Font_Name: 'Kristi',
              DefaultFont_Size: 42,
              CharBetween23_30: 32,
              CharBetween31_40: 26,
              CharBetween41_100: 22,
            },
            {
              Font_id: 8,
              Font_Name: 'Nothing you could do',
              DefaultFont_Size: 22,
              CharBetween23_30: 16,
              CharBetween31_40: 14,
              CharBetween41_100: 12,
            },
            {
              Font_id: 9,
              Font_Name: 'Allison',
              DefaultFont_Size: 42,
              CharBetween23_30: 32,
              CharBetween31_40: 26,
              CharBetween41_100: 20,
            },
            {
              Font_id: 10,
              Font_Name: 'Zeyada',
              DefaultFont_Size: 36,
              CharBetween23_30: 24,
              CharBetween31_40: 20,
              CharBetween41_100: 16,
            },
            {
              Font_id: 11,
              Font_Name: 'Mrs Saint Delafield',
              DefaultFont_Size: 38,
              CharBetween23_30: 28,
              CharBetween31_40: 22,
              CharBetween41_100: 18,
            },
          );

          this.selectedFontData = {
            Font_id: -1,
            Font_Name: 'Montserrat',
            DefaultFont_Size: 22,
            CharBetween23_30: 16,
            CharBetween31_40: 14,
            CharBetween41_100: 10,
          };
        }
      }
    }

    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.isPreReadQn = this.questions?.filter((e) => e.population_type == 3).length > 0;
    this.Signature_SaveConfirm = this.service.getSurveyMessages()?.Signature_SaveConfirm;
    this.Signature_Clear = this.service.getSurveyMessages()?.Signature_Clear;
    this.Signature_TapSignHere = this.service.getSurveyMessages()?.Signature_TapSignHere;
    this.Signature_ClickSignHere = this.service.getSurveyMessages()?.Signature_ClickSignHere;
    this.Signature_UploadSignature = this.service.getSurveyMessages()?.Signature_UploadSignature;
    this.Signature_TypeHere = this.service.getSurveyMessages()?.Signature_TypeHere;
  }

  ngAfterViewInit() {
    if (window.navigator.userAgent.indexOf('Chrome') != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
    }

    if (!this.isSignatureControl) {
      var self = this;
      setTimeout(() => {
        let elemid = '#dv_' + self.firstQuestion.UniqueNumber;
        if (!self.isMobile) {
          if (
            self.firstQuestion.MTBTitleLocation == 1 ||
            self.firstQuestion.MTBTitleLocation == 3
          ) {
            $(elemid)
              .find('.answer-option-wrapper .mtb-wrapper')
              .each(function () {
                let questionClone = $(this).find('.question-option-wrapper').clone();
                $(this).find('.question-option-wrapper').remove();
                if (questionClone.length > 1 && $(this).find('.answer-option-wrapper').length > 1) {
                  $(this).find('.answer-option-wrapper').eq(0).after(questionClone[0]);
                  $(this).find('.answer-option-wrapper').eq(1).after(questionClone[1]);
                } else {
                  $(this).find('.answer-option-wrapper').after(questionClone);
                }
              });
          }
          if (self.questions[0].qsubtype == 71) {
            self.setSubQuestionWidth($(elemid));
          }
        }

        if (self.questions[0].qsubtype != 71) {
          self.setMtbLabelWidth(elemid);
        }
      }, 0); // Delay to ensure DOM is ready

      if (self.matrix?.MultiColumnCount > 1) {
        setTimeout(() => {
          let elemid = '#dv_' + self.firstQuestion.UniqueNumber;
          if ($(elemid).find('.answer-option-wrapper').outerWidth() > $(elemid).outerWidth()) {
            $(elemid).find('.div-scroll-btn').show();
          }
        }, 0);
        $(document).ready(function () {
          let elemid = '#dv_' + self.firstQuestion.UniqueNumber;
          $('.fieldset-wrapper-scroll').scroll(function () {
            if ($('.RTLDir').length > 0) {
              if ($(this).scrollLeft() == 0) {
                $(this).parents('.divScroll').find('.div-scroll-btn').hide();
              } else {
                $(elemid).parents('.divScroll').find('.div-scroll-btn').show();
              }
            } else {
              if (
                $(this).find('.answer-option-wrapper').outerWidth() - $(this).scrollLeft() <=
                $(this).outerWidth() + 5
              ) {
                $(this).parents('.divScroll').find('.div-scroll-btn').hide();
              } else {
                $(this).parents('.divScroll').find('.div-scroll-btn').show();
              }
            }
          });
        });
      } else {
        setTimeout(() => {
          let elemid = '#dv_' + self.firstQuestion.UniqueNumber;
          if ($(elemid).find('.answer-option-wrapper').outerWidth() < $(elemid).outerWidth()) {
            $(elemid).find('.div-scroll-btn').hide();
          }
        }, 0);
      }
    }

    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
        this.isResetPage = true;

        if (this.isSignatureControl) {
          this.clearControl();
        }
      }
    });
  }
  ngOnDestroy() {
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  isNgOnchangeCall(): boolean {
    if (
      this.questions[0].qsubtype != 71 ||
      (this.questions[0].qsubtype == 71 && this.isResetPage)
    ) {
      return true;
    } else {
      return false;
    }
  }

  isQuesionHideInQDL(): boolean {
    if (this.questions.find((e) => e.isCQ) != undefined) {
      return true;
    } else {
      return false;
    }
  }

  UpdateQuestionsData(question: Questions) {
    this.ChangeAnswersData.emit(question);
    let qn = this.questions.find((e) => e.UniqueNumber == question.UniqueNumber);
    this.questions[this.questions.indexOf(qn)] = question;
    if (question.AnswerText != null) {
      this.isAnsChange = true;
    }
  }

  AnsChangecall(isAnsChangecall: boolean) {
    this.isAnsChange = isAnsChangecall;
  }

  HorizontalHandling() {
    let previewData = this.service.getPreviewData();
    let DispAnsCol = this.matrix?.MultiColumnCount;
    let ansArray = [];

    let nonHiddenQs;
    if (previewData && previewData.isShowHiddenQN) {
      nonHiddenQs = [...this.questions];
    } else {
      nonHiddenQs = this.questions.filter(
        (e) => e.isCQHide == false && e.population_type != 2 && e.population_type != 5,
      );
    }

    let answerLength = nonHiddenQs.length;
    let rowCount = Math.ceil(answerLength / DispAnsCol);

    this.columnWidth = 100 / DispAnsCol;

    for (let i = 0; i < rowCount; i++) {
      let tempArray = [];
      let counter = 0;
      let index = 0;
      for (let j = i * DispAnsCol; j < answerLength; j++) {
        counter++;
        tempArray.push(nonHiddenQs[j]);

        if (nonHiddenQs[j].Answers[0].hasMedia || nonHiddenQs[j].Answers[0].hasImage) {
          this.SingleAndMultiImageHandling(index, 0, nonHiddenQs[j]);
        }
        index++;
        if (counter == DispAnsCol) {
          break;
        }
      }
      ansArray.push(tempArray);
    }

    this.tempArray[0] = ansArray;
    this.questionsArray = this.tempArray;
  }

  GetQuestionsString(question): string {
    return JSON.stringify(question);
  }

  setSubQuestionWidth(obj) {
    $('#' + obj[0].id + ' .question-text-span').css('white-space', 'nowrap');
    let subQWidth = 0;

    obj.find('.question-option-wrapper.subqtn').each(function () {
      if ($(this).outerWidth() > subQWidth) {
        subQWidth = $(this).outerWidth() + 30;
      }
    });

    if (subQWidth > 400) {
      subQWidth = 400;
    }
    obj.find('.answer-option-wrapper .question-option-wrapper').css('min-width', subQWidth + 'px');
    obj.find('.answer-option-wrapper .question-option-wrapper').css('width', subQWidth + 'px');

    $('#' + obj[0].id + ' .question-text-span').css('white-space', 'normal');
  }

  GetSubQnNumber(): boolean {
    return this.isDisplayQno;
  }

  setMtbLabelWidth(objId) {
    let elemWidth = 0;
    if (
      !$(objId).find('.question-option-wrapper.subqtn').parents().hasClass('.column-struct-mtb')
    ) {
      $(objId)
        .find('.question-option-wrapper.subqtn')
        .each(function () {
          if ($(this).outerWidth() >= elemWidth) {
            if ($(this).outerWidth() <= 400) {
              elemWidth = $(this).outerWidth();
            } else {
              elemWidth = 400;
            }
          }
        });
      if (elemWidth < 40) {
        elemWidth = 40;
      } else {
        elemWidth = elemWidth + 28;
      }

      $(objId)
        .find('.question-option-wrapper.subqtn')
        .css('width', elemWidth + 'px');
      $(objId)
        .find('.question-option-wrapper.subqtn')
        .css('min-width', elemWidth + 'px');
      $(objId).find('.question-option-wrapper.subqtn').css('white-space', 'normal');
    }
  }

  getPipingTitle(group_no: number): string {
    return this.service.getPiping(group_no);
  }

  getHiddenQuestions(questions: Questions, service: ParticipationDataService) {
    if (
      service.getGroupType()?.toLowerCase() == 'preview' &&
      service.getPreviewData().isShowHiddenQN
    ) {
      return true;
    } else {
      return (
        (questions.population_type != 2 &&
          questions.population_type != 5 &&
          questions.isCQHide == false) ||
        service.getisEditResponse() == true
      );
    }
  }

  gotoNextQuestion(question: Questions, event) {
    if (
      this.questions.filter((e) => e.isValid).length == 0 &&
      this.questions.filter(
        (e) =>
          e.isValid == false &&
          e.qtype == 'T' &&
          e.qsubtype == 31 &&
          e.isreenter == 1 &&
          e.otherAnswer == null &&
          e.AnswerText != null,
      ).length == 0
    ) {
      this.service.gotoNextQuestion(question, event);
    }
  }

  GetAnswerImages(question: Questions): AnswerImage[] {
    if (question.Answers[0].AnswerImages != null) {
      return question.Answers[0].AnswerImages;
    }
  }

  GetAnswerMedias(question: Questions): AnswerMedia[] {
    if (question.Answers[0].AnswerMedias != null) {
      return question.Answers[0].AnswerMedias;
    }
  }

  SingleAndMultiImageHandling(index: number, j: number, question: Questions) {
    if (
      (question.Answers[j].AnswerMedias != null && question.Answers[j].AnswerMedias.length > 1) ||
      (question.Answers[j].AnswerImages != null && question.Answers[j].AnswerImages.length > 1) ||
      this.multiImageArray.indexOf(index) >= 0
    ) {
      if (this.multiImageArray.indexOf(index) < 0) {
        this.multiImageArray.push(index);
      }

      if (this.singleImageArray.indexOf(index) >= 0) {
        this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
      }
    } else if (
      question.Answers[j].AnswerMedias != null &&
      question.Answers[j].AnswerMedias.length == 1 &&
      question.Answers[j].AnswerImages != null &&
      question.Answers[j].AnswerImages.length == 1
    ) {
      if (this.multiImageArray.indexOf(index) < 0) {
        this.multiImageArray.push(index);
      }

      if (this.singleImageArray.indexOf(index) >= 0) {
        this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
      }
    } else {
      if (this.singleImageArray.indexOf(index) < 0) {
        this.singleImageArray.push(index);
      }
    }
  }

  HasSingleImageClass(index: number): boolean {
    if (this.singleImageArray.indexOf(index) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  getMtbTItleLocation(): number {
    return this.questions[0].MTBTitleLocation;
  }

  getMultiColumnCount(): number {
    return this.matrix?.MultiColumnCount;
  }

  HasMultiImageClass(index: number): boolean {
    let abc = index;
    if (this.multiImageArray.indexOf(index) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  getAnsImageCSS() {
    if (this.questions.filter((e) => e.Answers[0].hasImage || e.Answers[0].hasMedia).length == 0) {
      return '';
    }

    if (
      this.questions.find(
        (e) =>
          (e.Answers[0].hasImage && e.Answers[0].AnswerImages.length == 2) ||
          (e.Answers[0].hasMedia && e.Answers[0].AnswerMedias.length == 2),
      ) != undefined
    ) {
      return 'mtb-multi-image';
    } else if (
      this.questions.find(
        (e) =>
          e.Answers[0].hasImage &&
          e.Answers[0].AnswerImages.length == 1 &&
          e.Answers[0].hasMedia &&
          e.Answers[0].AnswerMedias.length == 1,
      ) != undefined
    ) {
      return 'mtb-multi-image';
    } else if (
      this.questions.find(
        (e) =>
          (e.Answers[0].hasImage && e.Answers[0].AnswerImages.length == 1) ||
          (e.Answers[0].hasMedia && e.Answers[0].AnswerMedias.length == 1) != undefined,
      )
    ) {
      return 'mtb-single-image';
    } else {
      return '';
    }
  }

  getVerticalClass() {
    switch (this.matrix?.VerticalSpaceCount) {
      case 0:
        return 'v-small';
      case 1:
        return 'v-medium';
      case 2:
        return 'v-large';
      case 3:
        return 'v-xlarge';
    }
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }

  @HostListener('document:click')
  resetTimer() {
    if (this.ischangeStyle && !this.isfontChangeOpen) {
      this.ischangeStyle = false;
    }
    this.isfontChangeOpen = false;
  }

  drawComplete() {
    this.isSetImage = true;
    this.firstQuestion.isValid = true;
    this.firstQuestion.error_msg = this.service.getSurveyMessages().Signature_ClickSave;
    this.isErrormsg_fullwidth = false;
    this.ChangeAnswersData.emit(this.firstQuestion);
  }

  drawStart() {
    console.log('begin drawing');
  }

  setControlValueOnClick(val: number) {
    if (val == 2) {
      const fileInput = document.querySelector(
        `#signatureFile_${this.firstQuestion.qno}_${this.firstQuestion.UniqueNumber}`,
      ) as HTMLElement;
      if (fileInput) {
        fileInput.click();
      }
    } else {
      this.setControlValue = val;

      if (val == 3) {
        this.selectedFontData = {
          Font_id: -1,
          Font_Name: 'Montserrat',
          DefaultFont_Size: 22,
          CharBetween23_30: 16,
          CharBetween31_40: 14,
          CharBetween41_100: 10,
        };

        let id = `Q1__${this.firstQuestion.UniqueNumber}_T_ID`;

        setTimeout(() => {
          const control = document.getElementById(id);
          if (control) {
            control.focus();
          }
        }, 100);
      } else if (val == 1 && this.isMobile) {
        let width = $('.sign-box').width();
        this.signaturePadOptions = {
          backgroundColor: 'white',
          minWidth: 2,
          canvasWidth: width,
          canvasHeight: 144,
        };
      }
    }

    if (val == 1) {
      let id = 'scribble_container_' + this.firstQuestion.UniqueNumber;

      setTimeout(function () {
        let control = document.getElementById(id);
        control.focus();
      }, 0);
    }
  }

  setControlType(val: number) {
    this.setControlTypeValue = val;

    let id = 'signBox_' + this.firstQuestion.UniqueNumber;

    setTimeout(function () {
      let control = document.getElementById(id);
      control.focus();
    }, 0);

    if (this.firstQuestion.isValid) {
      this.firstQuestion.isValid = false;
      this.ChangeAnswersData.emit(this.firstQuestion);
    }
  }

  clearSignature() {
    if (this.signaturePad != undefined) {
      this.signaturePad.clear();
    }

    this.setControlValue = 0;

    if (this.group.IsScribbledSignature) {
      this.setControlTypeValue = 1;
    } else if (this.group.IsUploadImageSignature) {
      this.setControlTypeValue = 2;
    } else if (this.group.IsTypeSignature) {
      this.setControlTypeValue = 3;
    }

    this.isSetImage = false;
    this.questions[0].AnswerText = null;
    this.selectedFontName = 'Montserrat';
    this.selectFontValue = -1;
    this.fontPixel = 24;
    this.textSignatureValue = null;
    this.signatureImg = null;
    this.deleteFileInput();

    let id = 'signBox_' + this.firstQuestion.UniqueNumber;

    setTimeout(function () {
      let control = document.getElementById(id);
      control.focus();
    }, 50);
  }

  blurData(event: any) {
    if (event.target.value != null && event.target.value.trim() != '') {
      this.isSetImage = true;
      this.firstQuestion.isValid = true;
      this.firstQuestion.error_msg = this.service.getSurveyMessages().Signature_ClickSave;
      this.isErrormsg_fullwidth = false;
      this.ChangeAnswersData.emit(this.firstQuestion);
    } else {
      this.isSetImage = false;

      if (this.firstQuestion.isValid) {
        this.firstQuestion.isValid = false;
        this.ChangeAnswersData.emit(this.firstQuestion);
      }
    }
  }
  applyFontStyle(font: FontDataForSignature) {
    this.ischangeStyle = false;
    this.selectedFontName = font.Font_Name;
    this.selectFontValue = font.Font_id;
    this.fontPixel = font.DefaultFont_Size;
    this.isfontChangeOpen = false;
    this.selectedFontData = font;
  }

  fontChange(id: number) {
    this.ischangeStyle = true;
    this.isfontChangeOpen = true;
  }

  handleFileInput(file: FileList) {
    if (file[0]) {
      if (
        file[0].type == 'image/jpeg' ||
        file[0].type == 'image/png' ||
        file[0].type == 'image/jpg'
      ) {
        if (file[0].size < 5000000) {
          this.setControlValue = 2;
          this.isLoaderOnImage = true;
          const reader = new FileReader();
          reader.onload = (e) => (this.signatureImg = reader.result.toString());
          reader.readAsDataURL(file[0]);
          let formData: FormData = new FormData();
          formData.append(
            'signatureFiles',
            file[0],
            'signature_' + this.service.getRecNO() + '_' + this.firstQuestion.UniqueNumber + '.png',
          );
          this.postingFileInput(formData);
        } else {
          file.item = null;
          this.firstQuestion.error_msg =
            this.service.getSurveyMessages().Signature_FileSizeExeedMessage;
          this.firstQuestion.isValid = true;
          this.isErrormsg_fullwidth = true;
        }
      } else {
        file.item = null;
        this.firstQuestion.error_msg = this.service.getSurveyMessages().Signature_FileTypeMessage;
        this.firstQuestion.isValid = true;
        this.isErrormsg_fullwidth = true;
      }
    }
  }

  savePad(signatureType: number) {
    if (signatureType == 1) {
      if (!this.signaturePad.isEmpty()) {
        const base64Data = this.signaturePad.toDataURL();
        this.signatureImg = base64Data;
        this.convertURLDataToImage(this.signaturePad.toDataURL('image/png'));
        if (!this.firstQuestion.isValid) {
          if (this.isNewParticipation && (this.surveyFormat == 1 || this.surveyFormat == 2)) {
            let id = 'signatureWrapper_' + this.firstQuestion.UniqueNumber;
            let control = document.getElementById(id);
            this.gotoNextQuestion(this.firstQuestion, control);
          }
        }
      }
    } else {
      if (this.textSignatureValue != null && this.textSignatureValue.trim() != '') {
        var canvas = document.createElement('canvas');
        canvas.id = this.firstQuestion.UniqueNumber + '_ID';
        canvas.width = 400;
        canvas.height = 200;
        var ctx = canvas.getContext('2d');
        if (this.textSignatureValue.length <= 22) {
          ctx.font = `${this.selectedFontData.DefaultFont_Size}px ${this.selectedFontName}`;
        } else if (this.textSignatureValue.length > 22 && this.textSignatureValue.length <= 30) {
          ctx.font = `${this.selectedFontData.CharBetween23_30}px ${this.selectedFontName}`;
        } else if (this.textSignatureValue.length > 31 && this.textSignatureValue.length <= 40) {
          ctx.font = `${this.selectedFontData.CharBetween31_40}px ${this.selectedFontName}`;
        } else if (this.textSignatureValue.length > 41) {
          ctx.font = `${this.selectedFontData.CharBetween41_100}px ${this.selectedFontName}`;
        }
        ctx.textAlign = 'center';
        ctx.fillText(this.textSignatureValue, canvas.width / 2, canvas.height / 2);
        this.signatureImg = ctx.canvas.toDataURL();
        this.convertURLDataToImage(ctx.canvas.toDataURL('image/png'));
      }
    }
  }

  convertURLDataToImage(urlData: any) {
    this.firstQuestion.isValid = false;
    const data = atob(urlData.substring('data:image/png;base64,'.length)),
      asArray = new Uint8Array(data.length);

    for (var i = 0, len = data.length; i < len; ++i) {
      asArray[i] = data.charCodeAt(i);
    }

    const blob = new Blob([asArray], { type: 'image/png' });
    let formData: FormData = new FormData();
    formData.append(
      'signatureFiles',
      blob,
      'signature_' + this.service.getRecNO() + '_' + this.firstQuestion.UniqueNumber + '.png',
    );
    this.postingFileInput(formData);
  }

  postingFileInput(formData: FormData) {
    let surveykey = this.service.getSurveykey();
    let recno = this.service.getRecNO();
    let GroupType = this.service.getGroupType();
    let strStatus = '';

    let url =
      'postSignatureFile?k=' +
      surveykey +
      '&recNo=' +
      recno +
      '&qid=' +
      this.firstQuestion.UniqueNumber; 
    let strMessage = '';
    this.firstQuestion.AnswerText =
      'signature_' + this.service.getRecNO() + '_' + this.firstQuestion.UniqueNumber + '.png';
    this.firstQuestion.pageto = this.firstQuestion.Answers[0].pageto;
    this.firstQuestion.isValid = false;
    this.ChangeAnswersData.emit(this.firstQuestion);

    this.service.postAttachedFile(url, formData).subscribe(
      async (data) => {
        strMessage = await data;
        if (strMessage.toUpperCase() == 'SUCCESS') {
          this.isSetImage = false;
          this.isLoaderOnImage = false;
          this.changeDetect.detectChanges();
          let id = 'img_' + this.firstQuestion.UniqueNumber;

          setTimeout(function () {
            let control = document.getElementById(id);
            control.focus();
          }, 100);

          if (this.isNewParticipation && (this.surveyFormat == 1 || this.surveyFormat == 2)) {
            let id = 'signatureWrapper_' + this.firstQuestion.UniqueNumber;
            let control = document.getElementById(id);
            this.gotoNextQuestion(this.firstQuestion, control);
          }
        } else {
          this.firstQuestion.error_msg = strMessage;
          this.isErrormsg_fullwidth = false;
          this.firstQuestion.isValid = true;
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  deleteFileInput() {
    let surveykey = this.service.getSurveykey();
    let recno = this.service.getRecNO();
    let GroupType = this.service.getGroupType();
    let strStatus = '';

    if (GroupType.toUpperCase() == 'PREVIEW') {
      strStatus = '&status=preview';
    }

    let url =
      'DeleteSignatureFile?k=' +
      surveykey +
      '&recNo=' +
      recno +
      '&qid=' +
      this.firstQuestion.UniqueNumber +
      strStatus +
      '&fileName=' +
      'signature_' +
      this.service.getRecNO() +
      '_' +
      this.firstQuestion.UniqueNumber +
      '.png';
    let strMessage = '';

    this.service.DeleteSignatureFile(url).subscribe(
      async (data) => {
        strMessage = await data;
        if (strMessage.toUpperCase() == 'SUCCESS') {
          this.firstQuestion.AnswerText = null;
          this.firstQuestion.pageto = 0;
          this.firstQuestion.isValid = false;
          this.ChangeAnswersData.emit(this.firstQuestion);
          this.isSetImage = false;
        } else if (this.firstQuestion.isValid) {
          this.firstQuestion.isValid = false;
          this.ChangeAnswersData.emit(this.firstQuestion);
        }
      },
      (error) => {
        if (error.error.text.toUpperCase() == 'SUCCESS') {
          this.firstQuestion.AnswerText = null;
          this.firstQuestion.pageto = 0;
          this.firstQuestion.isValid = false;
          this.ChangeAnswersData.emit(this.firstQuestion);
          this.isSetImage = false;
        } else if (this.firstQuestion.isValid) {
          this.firstQuestion.isValid = false;
          this.ChangeAnswersData.emit(this.firstQuestion);
        }
        console.log(error);
      },
    );
  }

  textFontSize(): string {
    if (
      this.textSignatureValue != null &&
      this.textSignatureValue != undefined &&
      this.textSignatureValue != ''
    ) {
      if (this.textSignatureValue.length <= 22) {
        this.fontPixel = this.selectedFontData.DefaultFont_Size;
      } else if (this.textSignatureValue.length > 22 && this.textSignatureValue.length <= 30) {
        this.fontPixel = this.selectedFontData.CharBetween23_30;
      } else if (this.textSignatureValue.length > 31 && this.textSignatureValue.length <= 40) {
        this.fontPixel = this.selectedFontData.CharBetween31_40;
      } else if (this.textSignatureValue.length > 41) {
        this.fontPixel = this.selectedFontData.CharBetween41_100;
      }
    }
    return this.fontPixel + 'px';
  }

  clearControl() {
    if (this.group.IsScribbledSignature) {
      this.setControlTypeValue = 1;
    } else if (this.group.IsUploadImageSignature) {
      this.setControlTypeValue = 2;
    } else if (this.group.IsTypeSignature) {
      this.setControlTypeValue = 3;
    }

    if (this.signaturePad != undefined) {
      this.signaturePad.clear();
    }

    this.isSetImage = false;
    this.selectedFontName = 'Montserrat';
    this.selectFontValue = -1;
    this.fontPixel = 24;
    this.textSignatureValue = null;
    this.signatureImg = null;
    this.setControlValue = 0;
  }

  textSignatureValuelength(): boolean {
    if (
      this.textSignatureValue != null &&
      this.textSignatureValue != undefined &&
      this.textSignatureValue.trim() != ''
    ) {
      return true;
    } else {
      return false;
    }
  }

  isQuestionsPostPopulated(): boolean {
    let postpopQues = this.questions.filter(
      (e) => e.population_type == 4 || e.population_type == 5,
    );
    if (postpopQues.length > 0 && this.service.getisEditPostPop() == true) {
      return true;
    }
    return false;
  }

  isPostEditDisable(question: Questions): boolean {
    if (
      this.service.getisEditPostPop() == true &&
      question.population_type != 4 &&
      question.population_type != 5
    ) {
      return true;
    }
    return false;
  }
}
